import { useCallback } from 'react'
import { useActivitiesContext } from '../../../context'
import { openContentActionCreator } from '../../../state'

export function useHandlers() {
  const [, dispatch] = useActivitiesContext()

  const handleClick = useCallback(
    (event) => {
      dispatch(openContentActionCreator(event.currentTarget))
    },
    [dispatch],
  )

  return {
    handleClick,
  }
}
